var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.response
    ? _c("div", { staticClass: "search" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "wrap-header container" }, [
            _c("div", { staticClass: "totalResults" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.response.totalPosts) +
                  " resultados encontrados\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box align-items-center" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.term,
                    expression: "term",
                  },
                ],
                attrs: { type: "text", name: "term" },
                domProps: { value: _vm.term },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.changeTerm.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.term = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn", on: { click: _vm.changeTerm } },
                [_c("i", { staticClass: "icon-search" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sort" },
                [
                  _c("multiselect", {
                    attrs: {
                      "deselect-label": "",
                      "track-by": "name",
                      label: "name",
                      placeholder: "Select one",
                      options: _vm.orderOptions,
                      searchable: false,
                      "allow-empty": false,
                      showPointer: false,
                      showNoResults: false,
                      showLabels: false,
                    },
                    on: { input: _vm.changeFacet },
                    model: {
                      value: _vm.order,
                      callback: function ($$v) {
                        _vm.order = $$v
                      },
                      expression: "order",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [_vm._v("Filtros:")]),
            _vm._v(" "),
            _vm.response && _vm.response.totalPosts > 0
              ? _c("div", { staticClass: "facets" }, [
                  _c("div", { staticClass: "row row-cols-3" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", { attrs: { for: "facet-date" } }, [
                          _vm._v("Fecha"),
                        ]),
                        _vm._v(" "),
                        _c("date-picker", {
                          attrs: {
                            name: "facet-date",
                            type: "date",
                            placeholder: "Seleccione",
                            range: "",
                          },
                          on: { input: _vm.changeFacet },
                          model: {
                            value: _vm.filterDate,
                            callback: function ($$v) {
                              _vm.filterDate = $$v
                            },
                            expression: "filterDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.facetSections
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("label", [_vm._v("Sección")]),
                            _vm._v(" "),
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  options: _vm.facetSections.items,
                                  multiple: true,
                                  "clear-on-select": false,
                                  "preserve-search": true,
                                  taggable: false,
                                  placeholder: "Seleccione",
                                  label: "item",
                                  "track-by": "item",
                                  selectLabel: "Seleccionar",
                                  selectedLabel: "Seleccionado",
                                  deselectLabel: "Quitar",
                                  openDirection: "bottom",
                                },
                                on: { input: _vm.changeFacet },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " seleccionados"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c("div", [
                                            _c("span", [
                                              _vm._v(_vm._s(props.option.item)),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(props.option.count) +
                                                  ")"
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1538101695
                                ),
                                model: {
                                  value: _vm.sections,
                                  callback: function ($$v) {
                                    _vm.sections = $$v
                                  },
                                  expression: "sections",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "tag" }, [_c("span")]),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.facetTags
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("label", [_vm._v("Tema")]),
                            _vm._v(" "),
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  options: _vm.facetTags.items,
                                  multiple: true,
                                  "clear-on-select": false,
                                  "preserve-search": true,
                                  taggable: false,
                                  placeholder: "Seleccione",
                                  label: "item",
                                  "track-by": "item",
                                  selectLabel: "Seleccionar",
                                  selectedLabel: "Seleccionado",
                                  deselectLabel: "Quitar",
                                  openDirection: "bottom",
                                },
                                on: { input: _vm.changeFacet },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " seleccionados"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c("div", [
                                            _c("span", [
                                              _vm._v(_vm._s(props.option.item)),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(props.option.count) +
                                                  ")"
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1538101695
                                ),
                                model: {
                                  value: _vm.tags,
                                  callback: function ($$v) {
                                    _vm.tags = $$v
                                  },
                                  expression: "tags",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "tag" }, [_c("span")]),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.facetFeedTypes
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("label", [_vm._v("Tipo")]),
                            _vm._v(" "),
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  options: _vm.facetFeedTypes.items,
                                  multiple: true,
                                  "clear-on-select": false,
                                  "preserve-search": true,
                                  taggable: false,
                                  placeholder: "Seleccione",
                                  label: "item",
                                  "track-by": "item",
                                  selectLabel: "Seleccionar",
                                  selectedLabel: "Seleccionado",
                                  deselectLabel: "Quitar",
                                  openDirection: "bottom",
                                },
                                on: { input: _vm.changeFacet },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " seleccionados"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c("div", [
                                            _c("span", [
                                              _vm._v(_vm._s(props.option.item)),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(props.option.count) +
                                                  ")"
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1538101695
                                ),
                                model: {
                                  value: _vm.feedTypes,
                                  callback: function ($$v) {
                                    _vm.feedTypes = $$v
                                  },
                                  expression: "feedTypes",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "tag" }, [_c("span")]),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.facetFormats
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("label", [_vm._v("Formato")]),
                            _vm._v(" "),
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  options: _vm.facetFormats.items,
                                  multiple: true,
                                  "clear-on-select": false,
                                  "preserve-search": true,
                                  taggable: false,
                                  placeholder: "Seleccione",
                                  label: "item",
                                  "track-by": "item",
                                  selectLabel: "Seleccionar",
                                  selectedLabel: "Seleccionado",
                                  deselectLabel: "Quitar",
                                  openDirection: "bottom",
                                },
                                on: { input: _vm.changeFacet },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " seleccionados"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c("div", [
                                            _c("span", [
                                              _vm._v(_vm._s(props.option.item)),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(props.option.count) +
                                                  ")"
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1538101695
                                ),
                                model: {
                                  value: _vm.formats,
                                  callback: function ($$v) {
                                    _vm.formats = $$v
                                  },
                                  expression: "formats",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "tag" }, [_c("span")]),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.hasFacetSelected
                    ? _c("div", { staticClass: "selected-facets" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("Filtros"),
                        ]),
                        _vm._v(" "),
                        _vm.filterDate &&
                        _vm.filterDate.length > 1 &&
                        _vm.filterDate[0]
                          ? _c("div", [
                              _c("span", { staticClass: "name" }, [
                                _vm._v("Fecha:"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "cancel-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFilterDate()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.facetDate) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.sections && _vm.sections.length
                          ? _c(
                              "div",
                              [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v("Sección:"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.sections, function (item, index) {
                                  return _c(
                                    "button",
                                    {
                                      key: item.item,
                                      staticClass: "cancel-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeSection(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.item) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tags && _vm.tags.length
                          ? _c(
                              "div",
                              [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v("Tema:"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.tags, function (item, index) {
                                  return _c(
                                    "button",
                                    {
                                      key: item.item,
                                      staticClass: "cancel-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeTag(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.item) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.feedTypes && _vm.feedTypes.length
                          ? _c(
                              "div",
                              [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v("Tipo:"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.feedTypes, function (item, index) {
                                  return _c(
                                    "button",
                                    {
                                      key: item.item,
                                      staticClass: "cancel-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeFeedType(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.item) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.formats && _vm.formats.length
                          ? _c(
                              "div",
                              [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v("Formato:"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.formats, function (item, index) {
                                  return _c(
                                    "button",
                                    {
                                      key: item.item,
                                      staticClass: "cancel-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeFormat(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.item) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "container",
            attrs: { "data-mrf-recirculation": "Listado de Noticias" },
          },
          [
            _vm.response && _vm.response.totalPosts > 0
              ? _c(
                  "div",
                  {
                    staticClass: "results",
                    attrs: { "data-epica-module-name": "Resultados Búsqueda" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "result-list",
                        attrs: { id: "sticky-anchor-1" },
                      },
                      [
                        _vm.quoteResponse && _vm.quoteResponse.length
                          ? _c(
                              "div",
                              {
                                staticClass: "quotes",
                                attrs: {
                                  "data-epica-module-name":
                                    "Resultados Búsqueda",
                                  "data-mrf-recirculation": "Indicadores",
                                },
                              },
                              [
                                _c("h5", [_vm._v("Indicadores Relacionados")]),
                                _vm._v(" "),
                                _vm._l(_vm.quoteResponse, function (item) {
                                  return _c(
                                    "a",
                                    {
                                      key: item.id,
                                      staticClass: "btn",
                                      attrs: {
                                        href:
                                          "/redirect/" +
                                          item.acType +
                                          "/" +
                                          item.id,
                                      },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.response.posts, function (post) {
                          return _c(
                            "a",
                            {
                              key: post.id,
                              staticClass: "result",
                              attrs: { href: post.url },
                            },
                            [
                              _c("div", { staticClass: "info" }, [
                                _c("div", { staticClass: "d-flex iconTitle" }, [
                                  _c("i", {
                                    staticClass: "type",
                                    class: post.feedType,
                                    attrs: { title: post.feedType },
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("div", { staticClass: "kicker" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(post.header) +
                                          "\n                  "
                                      ),
                                      _c("span", { staticClass: "date" }, [
                                        _vm._v(_vm._s(post.createMoment)),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("h3", {
                                      domProps: {
                                        innerHTML: _vm._s(post.title),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h4",
                                      { staticClass: "author" },
                                      _vm._l(post.authors, function (au) {
                                        return _c("strong", {
                                          key: au,
                                          domProps: { innerHTML: _vm._s(au) },
                                        })
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "sp" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "footer" }, [
                                      _c(
                                        "div",
                                        { staticClass: "tags" },
                                        [
                                          post.tagNames && post.tagNames.length
                                            ? _c("i", {
                                                staticClass: "icon-tag",
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(
                                            post.tagNames,
                                            function (tag, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [_vm._v(_vm._s(tag))]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "sponsor" }, [
                      _c("div", { attrs: { id: "sticky-anchor-2" } }, [
                        _c("div", { attrs: { id: _vm.adId } }),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.response && _vm.response.totalPosts == 0
              ? _c("div", { staticClass: "not-found" }, [
                  _c("h5", [_vm._v("Sin resultados")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n        No hemos encontrado resultados relacionados a\n        "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.request.term))]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "view-more" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-9" }, [
                  _vm.response.totalPosts >
                  _vm.request.offset + _vm.request.limit
                    ? _c(
                        "button",
                        {
                          staticClass: "button mb-5",
                          on: { click: _vm.nextPage },
                        },
                        [
                          _c("a", { staticClass: "btn analisisSect" }, [
                            _vm._v("VER MÁS"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }